// removed by extract-text-webpack-plugin
module.exports = {"hatNav":"hatNav__hatNav--15qmY","iconNav":"hatNav__iconNav--2BN82","liIcon":"hatNav__liIcon--D0vWu","Nav":"hatNav__Nav--2WlrK","navBlock":"hatNav__navBlock--3rDCW","BurgerContainer":"hatNav__BurgerContainer--2AWO3"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hat/hatNav/hatNav.css
// module id = 68
// module chunks = 0